import Select from 'react-select';
import { withAnalyticsEvents, withAnalyticsContext, createAndFireEvent } from '@atlaskit/analytics-next';
import { name as packageName, version as packageVersion } from '../package.json';
import createSelect from './createSelect';

export var SelectWithoutAnalytics = createSelect(Select);
var createAndFireEventOnAtlaskit = createAndFireEvent('atlaskit');

export default withAnalyticsContext({
  componentName: 'select',
  packageName: packageName,
  packageVersion: packageVersion
})(withAnalyticsEvents({
  onChange: createAndFireEventOnAtlaskit({
    action: 'selected',
    actionSubject: 'item',

    attributes: {
      componentName: 'select',
      packageName: packageName,
      packageVersion: packageVersion
    }
  })
})(SelectWithoutAnalytics));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/select/dist/esm/Select.js
// module id = 166
// module chunks = 0